<div class="modal-header">
  <h4 class="modal-title pull-left">Create Account</h4>
  <button
    type="button"
    class="close pull-right circle-icon"
    aria-label="Close"
    role="button"
    (click)="hideAndReset()"
  >
    <img src="../assets/images/cross.svg" />
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="createForm">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group mb-4 no-float-fields">
          <label class="form-label">First Name *</label>
          <mat-form-field appearance="outline">
            <input
              matInput
              maxlength="15"
              formControlName="firstName"
              type="text"
              placeholder="Enter first name"
            />
          </mat-form-field>
          <p
            class="pass-note m-0 text-danger"
            *ngIf="
              createForm.get('firstName').hasError('required') &&
              (createForm.get('firstName').dirty ||
                createForm.get('firstName').touched)
            "
          >
            First Name is required
          </p>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group mb-4 no-float-fields">
          <label class="form-label">Last Name *</label>
          <mat-form-field appearance="outline">
            <input
              matInput
              maxlength="15"
              formControlName="lastName"
              type="text"
              placeholder="Enter last name"
            />
          </mat-form-field>
          <p
            class="pass-note m-0 text-danger"
            *ngIf="
              createForm.get('lastName').hasError('required') &&
              (createForm.get('lastName').dirty ||
                createForm.get('lastName').touched)
            "
          >
            Last Name is required
          </p>
        </div>
      </div>

      <div class="col-md-12">
        <div class="form-group mb-4 no-float-fields">
          <label class="form-label">Email *</label>
          <mat-form-field appearance="outline">
            <input
              matInput
              formControlName="email"
              type="text"
              placeholder="Enter email"
              email
            />
          </mat-form-field>
          <p
            class="pass-note m-0 text-danger"
            *ngIf="
              createForm.get('email').hasError('required') &&
              (createForm.get('email').dirty || createForm.get('email').touched)
            "
          >
            Email is required
          </p>
          <p
            class="pass-note m-0 text-danger"
            *ngIf="
              createForm.get('email').hasError('pattern') &&
              (createForm.get('email').dirty || createForm.get('email').touched)
            "
          >
            Invalid email
          </p>
        </div>
      </div>

      <div class="col-md-12">
        <div class="row mb-4">
          <div class="col-4 col-sm-4 pr-0">
            <div class="form-group no-float-fields m-0">
              <label class="form-label">Country code *</label>
              <mat-select class="w-100" formControlName="isdCode">
                <mat-option [value]="null">Select</mat-option>
                <mat-option
                  *ngFor="let list of isdFlagList"
                  [value]="list.value"
                >
                  <span>
                    <img width="20" [src]="list.text.split(',')[0]" />
                    {{ list.text.split(",")[1] }}
                  </span>
                </mat-option>
              </mat-select>
            </div>
          </div>

          <div class="col-7 col-sm-8">
            <div class="form-group no-float-fields m-0">
              <label class="form-label">Phone Number *</label>
              <mat-form-field appearance="outline">
                <input
                  matInput
                  class="col-12 inline"
                  type="text"
                  maxlength="30"
                  formControlName="mobileNumber"
                  placeholder="Enter Phone Number"
                />
              </mat-form-field>
            </div>
          </div>

          <p
            class="pass-note m-0 text-danger col-12"
            *ngIf="
              createForm.get('mobileNumber').hasError('required') &&
              (createForm.get('mobileNumber').dirty ||
                createForm.get('mobileNumber').touched)
            "
          >
            Phone Number is required
          </p>
          <p
            class="pass-note m-0 text-danger col-12"
            *ngIf="
              createForm.get('mobileNumber').hasError('validatePhoneNumber') &&
              (createForm.get('mobileNumber').dirty ||
                createForm.get('mobileNumber').touched)
            "
          >
            Invalid Number
          </p>
          <p
            class="pass-note m-0 text-danger col-12"
            *ngIf="
              createForm.get('mobileNumber').hasError('pattern') &&
              (createForm.get('mobileNumber').dirty ||
                createForm.get('mobileNumber').touched)
            "
          >
            Phone Number will accept alphanumeric and special characters like
            .,-_() only
          </p>
        </div>
      </div>

      <div class="col-md-12">
        <div class="form-group mb-4 no-float-fields">
          <label class="form-label">Company *</label>
          <mat-form-field appearance="outline">
            <input
              matInput
              type="text"
              formControlName="company"
              placeholder="Add company name if applicable"
            />
          </mat-form-field>
          <mat-hint>Use 'Self-employed' if applicable</mat-hint>
        </div>
      </div>

      <div class="col-md-12">
        <div class="form-group mb-4 no-float-fields">
          <label class="form-label">Street *</label>
          <mat-form-field appearance="outline">
            <input
              matInput
              type="text"
              formControlName="street"
              placeholder="Enter Street Number"
            />
          </mat-form-field>
          <p
            class="pass-note m-0 text-danger"
            *ngIf="
              createForm.get('street').hasError('required') &&
              (createForm.get('street').dirty ||
                createForm.get('street').touched)
            "
          >
            Street is required
          </p>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group mb-4 no-float-fields">
          <label class="form-label">City *</label>
          <mat-form-field appearance="outline">
            <input
              matInput
              type="text"
              formControlName="city"
              placeholder="Enter City"
            />
          </mat-form-field>
          <p
            class="pass-note m-0 text-danger"
            *ngIf="
              createForm.get('city').hasError('required') &&
              (createForm.get('city').dirty || createForm.get('city').touched)
            "
          >
            City is required
          </p>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group mb-4 no-float-fields">
          <label class="form-label">Country *</label>
          <mat-select
            *ngIf="countries !== undefined"
            placeholder="Select"
            formControlName="country"
          >
            <mat-option *ngFor="let list of countries" [value]="list.id"
              >{{ list.name }}
            </mat-option>
          </mat-select>
          <p
            class="pass-note m-0 text-danger"
            *ngIf="
              createForm.get('country').hasError('required') &&
              (createForm.get('country').dirty ||
                createForm.get('country').touched)
            "
          >
            Country is required
          </p>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group mb-4 no-float-fields">
          <label class="form-label">State/Region *</label>
          <mat-form-field appearance="outline">
            <input
              matInput
              type="text"
              formControlName="state"
              placeholder="Enter State/Region"
            />
          </mat-form-field>
          <p
            class="pass-note m-0 text-danger"
            *ngIf="
              createForm.get('state').hasError('required') &&
              (createForm.get('state').dirty || createForm.get('state').touched)
            "
          >
            State is required
          </p>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group mb-4 no-float-fields">
          <label class="form-label">Postal Code *</label>
          <mat-form-field appearance="outline">
            <input
              matInput
              type="text"
              maxlength="12"
              formControlName="postalCode"
              placeholder="Enter Postal Code"
            />
          </mat-form-field>
          <p
            class="pass-note m-0 text-danger"
            *ngIf="
              createForm.get('postalCode').hasError('required') &&
              (createForm.get('postalCode').dirty ||
                createForm.get('postalCode').touched)
            "
          >
            Postal Code is required
          </p>
          <p
            class="pass-note m-0 text-danger"
            *ngIf="
              createForm.get('postalCode').hasError('pattern') &&
              (createForm.get('postalCode').dirty ||
                createForm.get('postalCode').touched)
            "
          >
            Postal Code is not valid
          </p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group mb-3 no-float-fields">
          <label class="form-label">Password *</label>
          <span class="for-pass-show">
            <mat-form-field appearance="outline">
              <input
                matInput
                [type]="hidep ? 'password' : 'text'"
                maxlength="20"
                formControlName="password"
                placeholder="*******"
              />
              <mat-icon
                class="cursor-pointer"
                matSuffix
                role="button"
                (click)="hidep = !hidep"
              >
                {{ hidep ? "visibility_off" : "visibility" }}</mat-icon
              >
            </mat-form-field>
          </span>
          <p
            class="pass-note m-0 text-danger"
            *ngIf="
              createForm.get('password').hasError('required') &&
              (createForm.get('password').dirty ||
                createForm.get('password').touched)
            "
          >
            Password is required
          </p>
          <p
            class="pass-note m-0 text-danger"
            *ngIf="
              createForm.get('password').hasError('pattern') &&
              (createForm.get('password').dirty ||
                createForm.get('password').touched)
            "
          >
            Your password can be eight characters or more and should contain
            atleast one capital letter and a number.
          </p>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group mb-3 no-float-fields">
          <label class="form-label">Confirm Password *</label>
          <span class="for-pass-show">
            <mat-form-field appearance="outline">
              <input
                matInput
                [type]="hide ? 'password' : 'text'"
                formControlName="confirmPassword"
                placeholder="*******"
              />
              <mat-icon
                class="cursor-pointer"
                matSuffix
                role="button"
                (click)="hide = !hide"
              >
                {{ hide ? "visibility_off" : "visibility" }}</mat-icon
              >
            </mat-form-field>
          </span>
          <p
            class="pass-note m-0 text-danger"
            *ngIf="
              createForm.get('confirmPassword').hasError('required') &&
              (createForm.get('confirmPassword').dirty ||
                createForm.get('confirmPassword').touched)
            "
          >
            Confirm Password is required
          </p>
          <p
            class="pass-note m-0 text-danger"
            *ngIf="
              createForm.get('confirmPassword').hasError('mustMatch') &&
              (createForm.get('confirmPassword').dirty ||
                createForm.get('confirmPassword').touched)
            "
          >
            Confirm Password must match Password
          </p>
        </div>
      </div>
      <div class="col-12">
        <p class="pass-note m-0">
          Your password can be eight characters or more and should contain
          atleast one capital letter and a number.
        </p>
      </div>
    </div>

    <button
      type="submit"
      [disabled]="loading || !createForm.valid"
      class="btn btn-colored btn-login"
      role="button"
      (click)="submitCreateForm()"
    >
      <span
        *ngIf="loading"
        class="spinner-border spinner-border-sm mr-1"
      ></span>
      Create Account
    </button>

    <div class="no-account">
      Already have an Account?
      <a
        href="javascript:void(0)"
        role="button"
        (click)="modalRef.hide(); openModalFile('login')"
        >Log In</a
      >
    </div>
  </form>
</div>
